import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../theme';

export const useSelectsStyles = createStyles(({ css }) => ({
  selectArrow: css`
    padding-left: ${ThemeSpaces.SPACE_NORM}px;
    padding-right: 3px;
    width: auto;
    height: 20px;
    border-left: 1px solid currentColor;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
    color: ${ThemeColors.COLOR_GREY_BLUISH};
  `,
  searchIcon: css`
    margin-left: ${ThemeSpaces.SPACE_NORM0_5}px;
    margin-right: ${ThemeSpaces.SPACE_NORM0_5}px;
  `,
  selectLoading: css`
    font-size: 16px;
    color: ${ThemeColors.COLOR_GREY_BLUISH};
  `,
}));
